<template>
  <el-card
    style="height: 100%"
    shadow="always"
    v-loading="loading"
    :body-style="{ padding: '0px' }"
  >
    <div class="row p-3">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <h1 class="text-navy">Order Confirmation</h1>
      </div>
      <div class="col-12 d-none d-lg-block">
        <el-table :data="purchases.data">
          <el-table-column label="Trade #" prop="ref_id"> </el-table-column>
          <el-table-column label="Actions" prop="id">
            <template slot-scope="scope">
              <a
                v-if="scope.row.order_confirmation_url"
                class="has-interaction text-green mr-2"
                data-toggle="tooltip"
                data-placement="top"
                title="View"
                :href="scope.row.order_confirmation_url"
                target="_blank"
              >
                <i class="far fa-globe fa-lg"></i>
              </a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="col-12 d-lg-none">
        <el-table :data="purchases.data">
          <el-table-column label="BSA" prop="id"> </el-table-column>
          <el-table-column label="Actions" prop="id">
            <template slot-scope="scope">
              <a
                v-if="scope.row.order_confirmation_url"
                class="has-interaction text-green mr-2"
                data-toggle="tooltip"
                data-placement="top"
                title="View"
                :href="scope.row.order_confirmation_url"
                target="_blank"
              >
                <i class="far fa-globe fa-lg"></i>
              </a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="col-12 py-3 d-flex justify-content-center justify-content-xl-end"
      >
        <el-pagination
          small
          layout="prev, pager, next, total"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :background="true"
          :page-size="perPage"
          :page-count="purchases.last_page"
          :total="purchases.total"
        />
      </div>
    </div>
  </el-card>
</template>
<script>
import Purchase from "../../../modelsPortal/Purchase";
export default {
  props: {
    initial_business: {
      type: Object,
    },
    isProducer: {
      type: Number,
    },
  },
  data() {
    return {
      business: this.initial_business,
      purchases: [],
      loading: false,
      page: 1,
      currentPage: 1,
      perPage: 5,
    };
  },
  mounted() {
    this.getPurchases();
  },
  methods: {
    getPurchases(page = 1) {
      this.loading = true;

      let purchases = new Purchase()
        .page(page)
        .where("business_id", this.business.id)
        .whereIn("not_null", ["oc_sent_at", "oc_issued_at"])
        .select({
          purchases: ["id", "oc_sent_at", "oc_issued_at", "ref_id"],
        })
        .append("order_confirmation_url")
        .orderBy("-oc_sent_at")
        .params({ per_page: this.perPage });

      purchases
        .get()
        .then((res) => {
          this.loading = false;
          this.purchases = res;
          this.currentPage = page;
        })
        .catch((errors) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    handleCurrentChange(page = 1) {
      this.getPurchases(page);
    },
  },
};
</script>
